import { library } from '@fortawesome/fontawesome-svg-core'
import { faExclamationCircle, faTimes, faUser, faKey } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faTimes)
library.add(faExclamationCircle)
library.add(faUser)
library.add(faKey)

export default (app) => {
  app.component('fa', FontAwesomeIcon)
}
